module.exports = __webpack_public_path__ + "img/right-tick.e425edf8.svg";